import React, { useState, useEffect } from "react";
import { useViewportScroll, motion } from "framer-motion";

const mySkills = [
  "React.js",
  "TypeScript",
  "ReScript",
  "Rust",
  "Node.js",
  "AWS (S3, Lambda)",
  "System Design",
  "Git",
  "Figma",
  "LLM Integration",
];

const Skills = () => {
  const disableWidth = 880;
  const scrollFactor = 800;
  const { scrollYProgress } = useViewportScroll();

  const [y, setY] = useState(0);

  useEffect(() => {
    if (window.screen.width > disableWidth) {
      window.addEventListener("scroll", () => {
        setY(scrollYProgress.get() * scrollFactor);
      });
    }
  }, []);

  return (
    <div className="skills">
      <div className="container-fluid">
        <div className="wrapper center">
          <div className="skills-subtitle subtitle">SKILLS</div>
          <motion.div
            style={window.screen.width < disableWidth ? {} : { y: -y + 750 }}
            className="skills-list"
          >
            {mySkills.map((skill) => (
              <div className="skill" key={skill}>
                {skill}
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
